import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { brandLogo } from '../../../constants/brandAssets';
import coupleImage from './Couple-walking-together-vector.png';
import { LoginContext } from '../../../context/LoginContext';

const REDIRECT_SECONDS = 4;
const MATCHES_PATH = '/recently-joined-matches/';

const RegistrationThankYou = () => {
  const navigate = useNavigate();
  const { isLoggedIn, userData } = useContext(LoginContext);
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);
  const displayName = userData?.name || 'Member';

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login/', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!isLoggedIn) return undefined;

    const tick = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(tick);
          navigate(MATCHES_PATH, { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(tick);
  }, [isLoggedIn, navigate]);

  return (
    <div className="reg-thankyou-page">
      <header className="reg-thankyou-header">
        <Link to="/">
          <img src={brandLogo} alt="Hindu Sanjog" className="reg-thankyou-logo" />
        </Link>
      </header>

      <main className="reg-thankyou-content">
        <img src={coupleImage} alt="Couple" className="reg-thankyou-image" />
        <h1 className="reg-thankyou-title">Thank You, {displayName}!</h1>
        <p className="reg-thankyou-subtitle">
          Your registration is complete. We are taking you to your Desired Partner matches.
        </p>
        <p className="reg-thankyou-timer">
          Redirecting in {secondsLeft}s…
        </p>
        <Link to={MATCHES_PATH} className="reg-thankyou-btn" replace>
          View Desired Partner Matches
        </Link>
      </main>

      <style>{`
        .reg-thankyou-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(180deg, #fff5f7 0%, #ffffff 45%);
          padding: 1.5rem;
          font-family: Georgia, 'Times New Roman', serif;
        }
        .reg-thankyou-header {
          width: 100%;
          max-width: 960px;
          margin-bottom: 1rem;
        }
        .reg-thankyou-logo {
          width: 150px;
          height: auto;
        }
        .reg-thankyou-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          width: 100%;
          max-width: 520px;
          padding: 1rem 0 3rem;
        }
        .reg-thankyou-image {
          width: 100%;
          max-width: 280px;
          height: auto;
          margin-bottom: 1.25rem;
        }
        .reg-thankyou-title {
          font-size: 1.85rem;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 0.65rem;
        }
        .reg-thankyou-subtitle {
          font-size: 1.05rem;
          color: #6b7280;
          line-height: 1.5;
          margin: 0 0 0.75rem;
        }
        .reg-thankyou-timer {
          font-size: 0.95rem;
          color: #E53D5C;
          margin: 0 0 1.25rem;
          font-family: system-ui, sans-serif;
        }
        .reg-thankyou-btn {
          display: inline-block;
          background: #E53D5C;
          color: #fff !important;
          text-decoration: none;
          padding: 0.85rem 1.75rem;
          border-radius: 10px;
          font-weight: 600;
          font-size: 1rem;
          font-family: system-ui, sans-serif;
          transition: background 0.2s ease;
        }
        .reg-thankyou-btn:hover {
          background: #c73658;
          color: #fff !important;
        }
        @media (max-width: 576px) {
          .reg-thankyou-title { font-size: 1.45rem; }
          .reg-thankyou-image { max-width: 220px; }
          .reg-thankyou-btn { width: 100%; max-width: 320px; }
        }
      `}</style>
    </div>
  );
};

export default RegistrationThankYou;
